// extracted by mini-css-extract-plugin
module.exports = {"app-placeholder":"placeholder__app-placeholder","app-placeholder__grid":"placeholder__app-placeholder__grid","app-placeholder__column":"placeholder__app-placeholder__column"};